export const Environment = {
  Local: 'localhost',
  QA: 'qa',
  Production: 'production',
  DevelopmentTrendedVitals: 'development-trended-vitals',
};

export const AppLinks = {
  QA: 'https://app.staging.unuhealth.org',
  Production: 'https://app.unuhealth.org/',
  DevelopmentTrendedVitals: 'https://trended-vitals-app.staging.unuhealth.org',
};

export const HostNames = {
  [Environment.Local]: ['localhost', '127.0.0.1', '10.0.2.2'],
  [Environment.QA]: [AppLinks.QA],
  [Environment.Production]: [AppLinks.Production],
  [Environment.DevelopmentTrendedVitals]: [AppLinks.DevelopmentTrendedVitals],
};
